import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './css/InfoComponent.css';

const InfoComponent = (props) => {
    const { info } = props;

    return (
        <p className="info-component-container alegreya-font-family font-spacing-wider text-left-align m-l-20px m-r-20px">
            {info}
        </p>
    );
};

InfoComponent.propTypes = {
    info: PropTypes.string.isRequired,
};

export default memo(InfoComponent);
